import { useTranslate } from '@growtherapy/i18n';
import { Text } from '@growtherapy/sprout-ui';

/**
 * Custom heads-up toast shown while the soft-block auto-transition timer is counting
 * down, warning the client that they're about to be moved to the waiting room.
 *
 * Intentionally does not use the existing shared Toast component due to slightly
 * different design and UX attributes.
 */
export function SoftBlockAutoTransitionToast({ secondsToAutoTransition }: { secondsToAutoTransition: number }) {
  const t = useTranslate();

  return (
    <div className='fixed bottom-16 left-1/2 z-50 w-[calc(100%-2rem)] max-w-3xl -translate-x-1/2'>
      <div className='gap-y-1 rounded-2xl bg-neutral-200 p-5 shadow-lg rebrand:bg-surface-emphasis'>
        <Text as='h2' variant='md' className='font-semibold text-neutral-900'>
          {t('telehealth-core:preSessionMeasures.movingToWaitingRoom', { count: secondsToAutoTransition })}
        </Text>
        <Text as='p' variant='sm' className='text-neutral-800'>
          {t('telehealth-core:preSessionMeasures.autoTransitionToastBody')}
        </Text>
      </div>
    </div>
  );
}
